import { render, staticRenderFns } from "./RouterTabs.vue?vue&type=template&id=4b45db08&scoped=true&"
import script from "./RouterTabs.vue?vue&type=script&lang=ts&"
export * from "./RouterTabs.vue?vue&type=script&lang=ts&"
import style0 from "./RouterTabs.vue?vue&type=style&index=0&id=4b45db08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b45db08",
  null
  
)

export default component.exports